import {CSSProperties, FC, ReactNode} from 'react'
import {DefaultTheme, FlattenSimpleInterpolation} from 'styled-components'
import {StyledCreateMediaDate, StyledCreateMediaDateWrapper, StyledMediaRoot, StyledOverlay} from './style'

interface MediaProps {
    children?: ReactNode
    withOverlay?: boolean
    onClick?: () => void
    mediaStyles?: (theme: DefaultTheme) => FlattenSimpleInterpolation
    imageUrl?: string | null
    imageUrlWithStyle?: string
    width?: number
    height?: number
    radius?: number
    variant?: CSSProperties['backgroundSize']
    className?: string
    dataOfCreate?: string
}

export const Media: FC<MediaProps> = ({
    children,
    onClick,
    withOverlay = false,
    imageUrl,
    imageUrlWithStyle,
    height,
    width,
    radius = 0,
    variant = 'cover',
    className,
    mediaStyles,
    dataOfCreate
}) => {
    return (
        <StyledMediaRoot
            className={className}
            onClick={onClick}
            mediaStyles={mediaStyles}
            height={height}
            width={width}
            radius={radius}
            imageUrl={imageUrl}
            imageUrlWithStyle={imageUrlWithStyle}
            variant={variant}
        >
            {withOverlay && <StyledOverlay />}
            {dataOfCreate && (
                <StyledCreateMediaDateWrapper>
                    <StyledCreateMediaDate>{dataOfCreate}</StyledCreateMediaDate>
                </StyledCreateMediaDateWrapper>
            )}

            {children}
        </StyledMediaRoot>
    )
}

Media.displayName = 'Media'
